import { type FileWithServicesAndMenu } from '../almacen-insumos/egreso/models'
import { type AdditionalOutflowsModel } from '../models/additional-outflows.model'

export const isAdditionalOutflowModel = (
  item: FileWithServicesAndMenu | AdditionalOutflowsModel
): item is AdditionalOutflowsModel => {
  return (
    (item as AdditionalOutflowsModel).outflowType != null &&
    (item as AdditionalOutflowsModel).outflowDate != null
  )
}
